import { BaseModel } from 'lib/base-model.js';

class Session extends BaseModel {

	static login(email, password) {

	}

}

export { Session };